let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d03Lb")).then(() => parcelRequire('lV04b'));